import { History } from "history";

import {
  CreateGradeRequest,
  GradeDto,
  UpdateGradeRequest,
} from "../../interfaces/grade";
import { PaginateQuery, Paginated, SelectListDto } from "../../models";

//#region Grade select list by course

export const GET_GRADE_SELECT_LIST_BY_COURSE =
  "GET_GRADE_SELECT_LIST_BY_COURSE";
export const GET_GRADE_SELECT_LIST_BY_COURSE_SUCCESS: any =
  "GET_GRADE_SELECT_LIST_BY_COURSE_SUCCESS";
export const GET_GRADE_SELECT_LIST_BY_COURSE_ERROR: any =
  "GET_GRADE_SELECT_LIST_BY_COURSE_ERROR";
export const RESET_GRADE_SELECT_LIST_BY_COURSE: any =
  "RESET_GRADE_SELECT_LIST_BY_COURSE";

export interface GetGradeSelectListByCourseAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE;
  payload: { courseId: string };
}

export interface GetGradeSelectListByCourseSuccessAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE_SUCCESS;
  payload: SelectListDto[];
}

export interface GetGradeSelectListByCourseErrorAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE_ERROR;
  payload: any;
}

export interface ResetGradeSelectListByCourseAction {
  type: typeof RESET_GRADE_SELECT_LIST_BY_COURSE;
  payload: any;
}

//#endregion

//#region Grade select list by course

export const GET_GRADES_DETAIL_BY_COURSE = "GET_GRADES_DETAIL_BY_COURSE";
export const GET_GRADES_DETAIL_BY_COURSE_SUCCESS: any =
  "GET_GRADES_DETAIL_BY_COURSE_SUCCESS";
export const GET_GRADES_DETAIL_BY_COURSE_ERROR: any =
  "GET_GRADES_DETAIL_BY_COURSE_ERROR";
export const RESET_GRADES_DETAIL_BY_COURSE: any =
  "RESET_GRADES_DETAIL_BY_COURSE";

export interface GetGradesDetailByCourseAction {
  type: typeof GET_GRADES_DETAIL_BY_COURSE;
  payload: { courseId: string };
}

export interface GetGradesDetailByCourseSuccessAction {
  type: typeof GET_GRADES_DETAIL_BY_COURSE_SUCCESS;
  payload: SelectListDto[];
}

export interface GetGradesDetailByCourseErrorAction {
  type: typeof GET_GRADES_DETAIL_BY_COURSE_ERROR;
  payload: any;
}

export interface ResetGradesDetailByCourseAction {
  type: typeof RESET_GRADES_DETAIL_BY_COURSE;
  payload: any;
}

//#endregion

//#region Get Grades

export const GET_GRADES = "GET_GRADES";
export const GET_GRADES_SUCCESS: any = "GET_GRADES_SUCCESS";
export const GET_GRADES_ERROR: any = "GET_GRADES_ERROR";

export interface GetGradesAction {
  type: typeof GET_GRADES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetGradesSuccessAction {
  type: typeof GET_GRADES_SUCCESS;
  payload: Paginated<GradeDto>;
}

export interface GetGradesErrorAction {
  type: typeof GET_GRADES_ERROR;
  payload: any;
}
//#endregion

//#region Get Grade

export const GET_GRADE = "GET_GRADE";
export const GET_GRADE_SUCCESS: any = "GET_GRADE_SUCCESS";
export const GET_GRADE_ERROR: any = "GET_GRADE_ERROR";

export interface GetGradeAction {
  type: typeof GET_GRADE;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetGradeSuccessAction {
  type: typeof GET_GRADE_SUCCESS;
  payload: GradeDto;
}

export interface GetGradeErrorAction {
  type: typeof GET_GRADE_ERROR;
  payload: any;
}
//#endregion

//#region Add Grade

export const ADD_GRADE = "ADD_GRADE";
export const ADD_GRADE_SUCCESS: any = "ADD_GRADE_SUCCESS";
export const ADD_GRADE_ERROR: any = "ADD_GRADE_ERROR";

export interface AddGradeAction {
  type: typeof ADD_GRADE;
  payload: {
    request: CreateGradeRequest;
    history: History;
  };
}

export interface AddGradeSuccessAction {
  type: typeof ADD_GRADE_SUCCESS;
  payload: null;
}

export interface AddGradeErrorAction {
  type: typeof ADD_GRADE_ERROR;
  payload: any;
}
//#endregion

//#region Update Grade

export const UPDATE_GRADE = "UPDATE_GRADE";
export const UPDATE_GRADE_SUCCESS: any = "UPDATE_GRADE_SUCCESS";
export const UPDATE_GRADE_ERROR: any = "UPDATE_GRADE_ERROR";

export interface UpdateGradeAction {
  type: typeof UPDATE_GRADE;
  payload: {
    id: string;
    request: UpdateGradeRequest;
    history: History;
  };
}

export interface UpdateGradeSuccessAction {
  type: typeof UPDATE_GRADE_SUCCESS;
  payload: null;
}

export interface UpdateGradeErrorAction {
  type: typeof UPDATE_GRADE_ERROR;
  payload: any;
}
//#endregion

//#region Delete Grade

export const DELETE_GRADE_CONSENT: any = "DELETE_GRADE_CONSENT";
export const DELETE_GRADE = "DELETE_GRADE";
export const DELETE_GRADE_SUCCESS: any = "DELETE_GRADE_SUCCESS";
export const DELETE_GRADE_ERROR: any = "DELETE_GRADE_ERROR";

export interface DeleteGradeConsentAction {
  type: typeof DELETE_GRADE_CONSENT;
  payload: string;
}

export interface DeleteGradeAction {
  type: typeof DELETE_GRADE;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteGradeSuccessAction {
  type: typeof DELETE_GRADE_SUCCESS;
  payload: null;
}

export interface DeleteGradeErrorAction {
  type: typeof DELETE_GRADE_ERROR;
  payload: any;
}
//#endregion

//#region Grade select list by course local

export const GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL =
  "GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL";
export const GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_SUCCESS: any =
  "GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_SUCCESS";
export const GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_ERROR: any =
  "GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_ERROR";

export const RESET_GRADE_SELECT_LIST_BY_COURSE_LOCAL: any =
  "RESET_GRADE_SELECT_LIST_BY_COURSE_LOCAL";

export interface GetGradeSelectListByCourseLocalAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL;
  payload: { courseId: string };
}

export interface GetGradeSelectListByCourseLocalSuccessAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_SUCCESS;
  payload: SelectListDto[];
}

export interface GetGradeSelectListByCourseLLocalErrorAction {
  type: typeof GET_GRADE_SELECT_LIST_BY_COURSE_LOCAL_ERROR;
  payload: any;
}

export interface ResetGradeSelectListByCourseLLocalAction {
  type: typeof RESET_GRADE_SELECT_LIST_BY_COURSE_LOCAL;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetGradeSelectListByCourseAction
  | GetGradeSelectListByCourseSuccessAction
  | GetGradeSelectListByCourseErrorAction
  | GetGradesDetailByCourseAction
  | GetGradesDetailByCourseSuccessAction
  | GetGradesDetailByCourseErrorAction
  | GetGradesAction
  | GetGradesSuccessAction
  | GetGradesErrorAction
  | GetGradeAction
  | GetGradeSuccessAction
  | GetGradeErrorAction
  | AddGradeAction
  | AddGradeSuccessAction
  | AddGradeErrorAction
  | UpdateGradeAction
  | UpdateGradeSuccessAction
  | UpdateGradeErrorAction
  | DeleteGradeConsentAction
  | DeleteGradeAction
  | DeleteGradeSuccessAction
  | DeleteGradeErrorAction
  | GetGradeSelectListByCourseLocalAction
  | GetGradeSelectListByCourseLocalSuccessAction
  | GetGradeSelectListByCourseLLocalErrorAction
  | ResetGradeSelectListByCourseLLocalAction;
